<div class="d-flex flex-column" [ngClass]="(preview === true) ? '' : 'h-100'">
    <div class="sku__card--body">
        <ng-container *ngIf="current_plan_type !== plan_types.TIME_BOUND">
            <div class="row p-3 border-bottom" *ngIf="current_plan_type === plan_types.TIME_BOUND_AND_MEASURABLE">
                <div [ngClass]="(preview === true)?'preview-card col-4 p-3':'col-12'">
                    <p class="plan-name">
                        Recurring Fees
                    </p>
                    <div *ngFor="let item of table_data_recurring;let i = index">
                        <div class="unit-name mt-3">
                            {{ item.unit }}
                        </div>
                        <div class="price ">
                            € {{item.price}} / {{ item.billing_period }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row px-3">
                <div class="mt-3" [ngClass]="(preview === true) ? 'preview-card col-4 p-3' : (multi_tier ? 'col-6' : 'col-12')"
                    *ngFor="let item of table_data;let i = index">
                    <p class="plan-name">
                        {{formGroup?.get('tierNames')['controls'][i].value.name || item[0].tier_name || plan.name}}
                    </p>

                    <div *ngFor="let tierItem of table_data[i];let j = index">
                        <div class="unit-name mt-3">
                            <ng-container *ngIf="multi_tier">
                                From {{ tierItem.from_unit }} to {{ tierItem.to_unit }} {{ tierItem.unit }}
                            </ng-container>
                            <ng-container *ngIf="!multi_tier">
                                For {{ tierItem.size }} {{ tierItem.unit }}
                            </ng-container>
                        </div>
                        <div class="price ">
                            € {{tierItem.price}} / {{ billing_period }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="current_plan_type === plan_types.TIME_BOUND">
            <div class="row my-3">
                <div [ngClass]="(preview === true)?'preview-card col-4 p-3':'col-12'">
                    <p class="plan-name">
                        {{formGroup?.value?.name || plan.name }}
                    </p>
                    <div *ngFor="let item of table_data;let i = index">
                        <div class="unit-name mt-3">
                            {{ item.unit }}
                        </div>
                        <div class="price ">
                            € {{item.price}} / {{ item.billing_period }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="sku__card--footer align-self-end w-100" *ngIf="!preview">
        <div class="button text-center mt-3 justify-self-end">
            <ng-content select="[sharedCardAction]"></ng-content>
            <button *ngIf="actionTrigger === undefined" class="btn btn-primary " style="width:100%;"
                (click)="handleClick($event)" [disabled]="disabled">
                {{buttonLabel}}
            </button>
        </div>
    </div>
</div>